module.exports = __webpack_public_path__ + "static/media/earnedInADay_2000_3000.d6341498.png";